module.exports = __webpack_public_path__ + "img/replay-ar.71aff51f.png";